import { render, staticRenderFns } from "./ModelosCartaz.vue?vue&type=template&id=1dec5246"
import script from "./ModelosCartaz.vue?vue&type=script&lang=js"
export * from "./ModelosCartaz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports